export default "https://cdn-static.gokick.com/assets/67048a8b985695a5a0d96903cfbe49422bf26f75/images/systolic-smaller.187d7732286412ba55022faa30794641.svg";